var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296.934,
    height: 28.317,
    viewBox: "0 0 296.934 28.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_black_green",
    transform: "translate(0.005 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_id_2",
    "data-name": "Arrow id 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M665.743,28.051l-16.3-8.873a2.506,2.506,0,0,0-3.63,2.967l2.834,8.13-2.834,8.107a2.506,2.506,0,0,0,3.627,2.97l16.3-8.841a2.506,2.506,0,0,0,0-4.466Zm-13.357,6.188,1.077-3.081a2.723,2.723,0,0,0,0-1.742L652.38,26.3l7.305,3.981Z",
    transform: "translate(-458.197 -13.37)",
    fill: "#13984b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M510.469,35.569H495.934a4.524,4.524,0,0,0,1.858,2.822,6.15,6.15,0,0,0,3.644,1.037,7.375,7.375,0,0,0,2.66-.447,6.449,6.449,0,0,0,2.16-1.411l2.965,3.214q-2.715,3.107-7.93,3.107a12.538,12.538,0,0,1-5.749-1.269,9.292,9.292,0,0,1-3.859-3.516A9.689,9.689,0,0,1,490.327,34a9.82,9.82,0,0,1,1.339-5.09,9.382,9.382,0,0,1,3.679-3.537,11.385,11.385,0,0,1,10.34-.052,8.867,8.867,0,0,1,3.589,3.484,10.386,10.386,0,0,1,1.3,5.267Q510.576,34.175,510.469,35.569ZM497.435,29.39a4.559,4.559,0,0,0-1.571,2.93h9.466a4.611,4.611,0,0,0-1.571-2.9,4.7,4.7,0,0,0-3.142-1.089,4.8,4.8,0,0,0-3.182,1.063Z",
    transform: "translate(-347.953 -17.105)",
    fill: "#13984b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M587.235,26.251q2.2,2.143,2.2,6.356v11h-5.569V33.464a5.018,5.018,0,0,0-1-3.412,3.668,3.668,0,0,0-2.9-1.124,4.43,4.43,0,0,0-3.357,1.3,5.358,5.358,0,0,0-1.234,3.876v9.5H569.79V24.393h5.322v2.25a7.4,7.4,0,0,1,2.75-1.876,9.582,9.582,0,0,1,3.6-.659A7.907,7.907,0,0,1,587.235,26.251Z",
    transform: "translate(-404.344 -17.108)",
    fill: "#13984b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M745.317,8.232a8.847,8.847,0,0,1,3.447,3.464,10.452,10.452,0,0,1,1.249,5.2,10.452,10.452,0,0,1-1.249,5.2,8.847,8.847,0,0,1-3.447,3.461,9.788,9.788,0,0,1-4.875,1.231,7.394,7.394,0,0,1-6.037-2.5V26.5H729.08V0h5.572V9.321A7.421,7.421,0,0,1,740.439,7a9.794,9.794,0,0,1,4.878,1.234Zm-2.323,12.535a5.409,5.409,0,0,0,1.373-3.876,5.4,5.4,0,0,0-1.373-3.873,5,5,0,0,0-7.035,0,5.409,5.409,0,0,0-1.373,3.876,5.409,5.409,0,0,0,1.373,3.876,5,5,0,0,0,7.035,0Z",
    transform: "translate(-517.383)",
    fill: "#13984b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M810.88,0h5.572V26.5H810.88Z",
    transform: "translate(-575.431)",
    fill: "#13984b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M860.075,35.563H845.539a4.524,4.524,0,0,0,1.858,2.822,6.15,6.15,0,0,0,3.644,1.037,7.371,7.371,0,0,0,2.66-.447,6.449,6.449,0,0,0,2.16-1.411l2.973,3.214q-2.715,3.107-7.927,3.107a12.541,12.541,0,0,1-5.749-1.269A9.292,9.292,0,0,1,841.3,39.1a9.69,9.69,0,0,1-1.356-5.107,9.816,9.816,0,0,1,1.339-5.09,9.381,9.381,0,0,1,3.679-3.537,11.388,11.388,0,0,1,10.34-.052,8.868,8.868,0,0,1,3.589,3.484,10.385,10.385,0,0,1,1.3,5.267Q860.182,34.169,860.075,35.563ZM847.04,29.384a4.562,4.562,0,0,0-1.562,2.93h9.466a4.611,4.611,0,0,0-1.571-2.9,4.7,4.7,0,0,0-3.142-1.089,4.8,4.8,0,0,0-3.191,1.063Z",
    transform: "translate(-596.057 -17.099)",
    fill: "#13984b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M927.386,24.82a10.012,10.012,0,0,1,3.911-.714v5.142q-.929-.073-1.249-.073a5.114,5.114,0,0,0-3.751,1.339,5.417,5.417,0,0,0-1.365,4.013v9.08H919.36V24.39h5.322v2.535a6.2,6.2,0,0,1,2.7-2.105Z",
    transform: "translate(-652.413 -17.105)",
    fill: "#13984b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M966.3,43.348a12.216,12.216,0,0,1-3.641-1.484l1.858-4a11.661,11.661,0,0,0,3.1,1.356,13.019,13.019,0,0,0,3.571.517q3.537,0,3.537-1.742a1.239,1.239,0,0,0-.964-1.179,14.313,14.313,0,0,0-2.965-.607,28.5,28.5,0,0,1-3.894-.822,6.037,6.037,0,0,1-2.66-1.643,4.674,4.674,0,0,1-1.124-3.357,5.258,5.258,0,0,1,1.054-3.232,6.783,6.783,0,0,1,3.072-2.2,13.125,13.125,0,0,1,4.768-.787,18.7,18.7,0,0,1,4.065.447,11.352,11.352,0,0,1,3.339,1.231l-1.858,3.963a11.091,11.091,0,0,0-5.537-1.429,5.628,5.628,0,0,0-2.677.5,1.47,1.47,0,0,0-.891,1.286,1.272,1.272,0,0,0,.964,1.249,17.01,17.01,0,0,0,3.072.679,33.013,33.013,0,0,1,3.859.839,5.807,5.807,0,0,1,2.613,1.626,4.616,4.616,0,0,1,1.106,3.287A5.076,5.076,0,0,1,979,41.031a6.841,6.841,0,0,1-3.124,2.16,13.937,13.937,0,0,1-4.875.767A18.659,18.659,0,0,1,966.3,43.348Z",
    transform: "translate(-683.14 -17.152)",
    fill: "#13984b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M5.194,42.612A9.483,9.483,0,0,1,1.373,39.1a10.165,10.165,0,0,1,0-10.215,9.492,9.492,0,0,1,3.821-3.519,11.815,11.815,0,0,1,5.517-1.269,10.7,10.7,0,0,1,5.3,1.269A7.523,7.523,0,0,1,19.317,29L15,31.323a4.725,4.725,0,0,0-4.321-2.642A4.893,4.893,0,0,0,7.07,30.109,5.261,5.261,0,0,0,5.641,34,5.261,5.261,0,0,0,7.07,37.9a4.887,4.887,0,0,0,3.606,1.429A4.673,4.673,0,0,0,15,36.683l4.321,2.358a7.671,7.671,0,0,1-3.3,3.571,10.575,10.575,0,0,1-5.3,1.269,11.809,11.809,0,0,1-5.517-1.269Z",
    transform: "translate(0.004 -17.095)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M73.867,42.608a9.416,9.416,0,0,1-3.775-3.519,10.3,10.3,0,0,1,0-10.215,9.425,9.425,0,0,1,3.775-3.519,12.289,12.289,0,0,1,10.877,0A9.46,9.46,0,0,1,88.5,28.874a10.3,10.3,0,0,1,0,10.215,9.451,9.451,0,0,1-3.751,3.519,12.289,12.289,0,0,1-10.877,0Zm8.963-4.75a5.419,5.419,0,0,0,1.376-3.876,5.386,5.386,0,0,0-1.376-3.876,4.646,4.646,0,0,0-3.519-1.452,4.7,4.7,0,0,0-3.537,1.452,5.362,5.362,0,0,0-1.394,3.876,5.36,5.36,0,0,0,1.4,3.879,4.7,4.7,0,0,0,3.537,1.452,4.646,4.646,0,0,0,3.513-1.452Z",
    transform: "translate(-48.776 -17.091)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M168.615,26.244q2.2,2.143,2.2,6.356v11h-5.569V33.457a5.018,5.018,0,0,0-1-3.412,3.668,3.668,0,0,0-2.9-1.124,4.43,4.43,0,0,0-3.357,1.3,5.4,5.4,0,0,0-1.249,3.876v9.5H151.17V24.386h5.322v2.25a7.4,7.4,0,0,1,2.758-1.876,9.582,9.582,0,0,1,3.606-.662A7.9,7.9,0,0,1,168.615,26.244Z",
    transform: "translate(-107.275 -17.101)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M239.891,32.995a5.72,5.72,0,0,1-2.018.912,10.232,10.232,0,0,1-2.517.29,7.505,7.505,0,0,1-5.3-1.742,6.679,6.679,0,0,1-1.876-5.142V19.423H225.21V15.138h2.965V10.46h5.572v4.678h4.785v4.286h-4.785v7.822a2.613,2.613,0,0,0,.624,1.876,2.323,2.323,0,0,0,1.768.659,3.58,3.58,0,0,0,2.25-.714Z",
    transform: "translate(-159.817 -7.423)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M296.649,35.562H282.111a4.524,4.524,0,0,0,1.858,2.822,6.15,6.15,0,0,0,3.644,1.037,7.375,7.375,0,0,0,2.66-.447,6.449,6.449,0,0,0,2.16-1.411l2.965,3.214q-2.715,3.107-7.93,3.107a12.538,12.538,0,0,1-5.749-1.269,9.291,9.291,0,0,1-3.856-3.519,9.689,9.689,0,0,1-1.356-5.107,9.82,9.82,0,0,1,1.339-5.09,9.381,9.381,0,0,1,3.679-3.537,11.385,11.385,0,0,1,10.34-.052,8.868,8.868,0,0,1,3.589,3.484,10.386,10.386,0,0,1,1.3,5.267Q296.754,34.168,296.649,35.562Zm-13.031-6.179a4.559,4.559,0,0,0-1.571,2.93h9.463a4.611,4.611,0,0,0-1.571-2.9A4.7,4.7,0,0,0,286.8,28.32a4.8,4.8,0,0,0-3.179,1.063Z",
    transform: "translate(-196.218 -17.098)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M373.422,26.244q2.2,2.143,2.2,6.356v11h-5.557V33.457a5.018,5.018,0,0,0-1-3.412,3.668,3.668,0,0,0-2.9-1.124,4.43,4.43,0,0,0-3.357,1.3,5.4,5.4,0,0,0-1.249,3.876v9.5H356V24.386h5.322v2.25a7.4,7.4,0,0,1,2.75-1.876,9.582,9.582,0,0,1,3.606-.662A7.857,7.857,0,0,1,373.422,26.244Z",
    transform: "translate(-252.63 -17.101)",
    fill: "#221f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M444.681,32.995a5.72,5.72,0,0,1-2.018.912,10.232,10.232,0,0,1-2.517.29,7.505,7.505,0,0,1-5.3-1.742,6.679,6.679,0,0,1-1.876-5.142V19.423H430V15.138h2.965V10.46h5.572v4.678h4.785v4.286h-4.785v7.822a2.613,2.613,0,0,0,.624,1.876,2.323,2.323,0,0,0,1.768.659,3.58,3.58,0,0,0,2.25-.714Z",
    transform: "translate(-305.144 -7.423)",
    fill: "#221f1f"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1d5e37e22d4994ff112ea0ce60160cec.svg";
export { ForwardRef as ReactComponent };